import { Component, EventEmitter, Output } from '@angular/core';
import { SIDENAVA_META } from '../../constants/side-nav.cnst';
import { WebBuilderService } from '../../services/web-builder.service';
import { WebServiceService } from '../../services/web-service.service';

@Component({
  selector: 'lib-web-sidenav',
  templateUrl: './web-sidenav.component.html',
  styleUrls: ['./web-sidenav.component.scss']
})
export class WebSidenavComponent {
  selectedSection: string = '';
  menus = SIDENAVA_META;

  constructor(private webSerive: WebServiceService) {
    this.webSerive.selectedOption$.subscribe((value) => {
      this.selectedSection = value.label;
    })
  }

  ngOnInit(): void {
    const lastSelectedOption = localStorage.getItem('lastSelectedOption');
    if (lastSelectedOption) {
      this.webSerive.setSelectedOption(lastSelectedOption, true);
    }
    this.webSerive.selectedOption$.subscribe((value) => {
      this.selectedSection = value.label;
    })
  }

  onSelectSidemenuOption(option: string) {
    this.webSerive.setSidenavContentlistOption('default',false);
    if(option != this.selectedSection) {
      this.webSerive.setSelectedOption(option,true);
      this.selectedSection = option;
    }
    else{
      this.webSerive.setSelectedOption('default',false);
      this.selectedSection = '';
    }
  }
}
